<!-- Mismo borde y alto que los filtros; la opción elegida se marca con un segmento gris claro.
     Con textos (p. ej. PDF/URL en Concierge) ocupa todo el ancho del contenedor, como antes. -->
<div
  class="tw-inline-flex tw-h-9 tw-items-center tw-gap-0.5 tw-rounded-full tw-border-[0.5px] tw-border-solid tw-border-border-light-gray tw-bg-white tw-p-0.5"
  [class.tw-w-full]="!!(leftText || rightText)"
>
  <ng-container *ngFor="let type of options; let i = index">
    <button
      (click)="handleSelectedOption(type)"
      type="button"
      class="tw-flex tw-h-full tw-items-center tw-justify-center tw-rounded-full tw-transition-colors hover:tw-bg-gray-50 [&:not(:focus-visible)]:tw-outline-none focus-visible:[outline:auto]"
      [ngClass]="{
        '!tw-bg-gray-100': selectedType === type,
        'tw-w-10': (i === 0 && !leftText) || (i === 1 && !rightText),
        'tw-flex-1': (i === 0 && leftText) || (i === 1 && rightText),
        'tw-px-3': (i === 0 && leftText) || (i === 1 && rightText)
      }"
      [mhTooltip]="getTooltip(i, type) | translate"
      width="tw-w-fit"
    >
      <!-- Text mode for left option -->
      <span *ngIf="i === 0 && leftText" class="tw-whitespace-nowrap tw-text-xs tw-font-semibold tw-uppercase tw-font-[Rubik]" [ngClass]="{ 'tw-text-neutral-800': selectedType === type, 'tw-text-neutral-400': selectedType !== type }">
        {{ leftText }}
      </span>

      <!-- Text mode for right option -->
      <span *ngIf="i === 1 && rightText" class="tw-whitespace-nowrap tw-text-xs tw-font-semibold tw-uppercase tw-font-[Rubik]" [ngClass]="{ 'tw-text-neutral-800': selectedType === type, 'tw-text-neutral-400': selectedType !== type }">
        {{ rightText }}
      </span>

      <!-- Icon mode for left option (default) -->
      <div class="tw-flex tw-flex-col tw-items-center tw-justify-center" *ngIf="i === 0 && !leftText">
        <div class="tw-w-4 tw-h-[2.5px] tw-transition-colors" [ngClass]="selectedType === type ? 'tw-bg-neutral-800' : 'tw-bg-neutral-400'"></div>
        <div class="tw-w-4 tw-h-[2.5px] tw-my-[2px] tw-transition-colors" [ngClass]="selectedType === type ? 'tw-bg-neutral-800' : 'tw-bg-neutral-400'"></div>
        <div class="tw-w-4 tw-h-[2.5px] tw-transition-colors" [ngClass]="selectedType === type ? 'tw-bg-neutral-800' : 'tw-bg-neutral-400'"></div>
      </div>

      <!-- Icon mode for right option (default) -->
      <div class="tw-flex tw-flex-col tw-items-center tw-justify-center" *ngIf="i === 1 && !rightText">
        <div class="tw-w-4 tw-h-[4px] tw-mb-[2px] tw-transition-colors" [ngClass]="selectedType === type ? 'tw-bg-neutral-800' : 'tw-bg-neutral-400'"></div>
        <div class="tw-w-4 tw-h-[4px] tw-transition-colors" [ngClass]="selectedType === type ? 'tw-bg-neutral-800' : 'tw-bg-neutral-400'"></div>
      </div>
    </button>
  </ng-container>
</div>
